import { Link } from "react-router-dom";
import { useMagazineModal } from "./Nav";
import { ArrowRight } from "lucide-react";

export default function Footer() {
  const { open } = useMagazineModal();
  return (
    <footer className="border-t border-white/5 bg-black" data-testid="main-footer">
      {/* JOIN NOCTURNE BAND */}
      <div className="border-b border-white/5">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <p className="overline mb-5">Newsletter</p>
            <h2 className="font-display text-5xl md:text-7xl text-white leading-[1] mb-6">
              Join <span className="italic text-[var(--gb-gold)]">Nocturne.</span>
            </h2>
            <p className="text-white/65 text-base md:text-lg max-w-xl leading-relaxed">
              Receive every edition, exclusive films and behind the scenes stories.
            </p>
          </div>
          <div className="md:col-span-5 flex md:justify-end">
            <button
              data-testid="footer-join-nocturne-button"
              onClick={() => open("footer-join-nocturne")}
              className="gb-btn-primary"
            >
              Download Latest Magazine <ArrowRight size={14} />
            </button>
          </div>
        </div>
      </div>

      {/* LINK GRID */}
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-12">
        <div className="col-span-2 md:col-span-5">
          <p className="overline mb-6">Good Bandit · Est. 2024</p>
          <h3 className="font-display text-3xl md:text-4xl text-white leading-[1.15] max-w-md italic">
            <span className="text-[var(--gb-gold)]">Cinematic storytelling and strategic campaigns</span> for brands to engage audiences and deliver measurable impact.
          </h3>
        </div>

        <div className="md:col-span-2 md:col-start-7">
          <p className="kbd mb-5">EXPLORE</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/nocturne" className="gb-link">Nocturne</Link></li>
            <li><Link to="/films" className="gb-link">Films</Link></li>
            <li><Link to="/services" className="gb-link">Services</Link></li>
            <li><Link to="/journal" className="gb-link">Journal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="kbd mb-5">STUDIO</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/about" className="gb-link">About</Link></li>
            <li><Link to="/contact" className="gb-link">Contact</Link></li>
            <li><Link to="/garage" className="gb-link">The Garage</Link></li>
            <li><Link to="/admin/login" className="gb-link">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="kbd mb-5">CONTACT</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li>hello@thegoodbandit.com</li>
            <li>thegoodbandit.com</li>
          </ul>
        </div>
      </div>

      {/* BRAND BAND */}
      <div className="border-t border-white/5 overflow-hidden">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-display text-5xl md:text-7xl text-white tracking-tight leading-none">
            GOOD BANDIT
          </p>
          <p className="kbd text-white/50 max-w-sm md:text-right leading-[1.8]">
            CINEMATIC STORYTELLING FOR BRANDS
            <br />
            AND THE MOMENTS THAT MOVE US
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="kbd">© 2026 GOOD BANDIT · ALL RIGHTS RESERVED</p>
          <p className="kbd">PRIVACY · CASL · GDPR FRIENDLY</p>
        </div>
      </div>
    </footer>
  );
}
